import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import Toast from './Toast';
import DialogBox from './DialogBox';
import Loader from './Loader';
import ScreenBlocker from './ScreenBlocker';
import { clearToast } from "../../Redux/OverlayActions";

function OverlayHandler() {
    const dispatch = useDispatch();
    const toastTimeoutRef = useRef(null);

    const toast = useSelector(state => state.overlay.toast || null);
    const dialog = useSelector(state => state.overlay.dialog || null);
    const loader = useSelector(state => state.overlay.loader || null);
    const screenBlocker = useSelector(state => state.overlay.screenBlocker || false);

    // Handle toast auto-dismiss with proper cleanup
    useEffect(() => {
        if (toast !== null) {
            // Clear any existing timeout to prevent stacking
            if (toastTimeoutRef.current) {
                clearTimeout(toastTimeoutRef.current);
            }

            // Schedule new timeout
            toastTimeoutRef.current = setTimeout(() => {
                dispatch(clearToast());
            }, 5000);
        }

        // Cleanup on unmount or when toast changes
        return () => {
            if (toastTimeoutRef.current) {
                clearTimeout(toastTimeoutRef.current);
            }
        };
    }, [toast, dispatch]);

    return (
        <div>
            {toast !== null && <Toast
                theme={toast.theme}
                message={toast.message}
            />}
            {dialog !== null && <DialogBox
                theme={dialog.theme}
                title={dialog.title}
                message={dialog.message}
                btn1Text={dialog.btn1Text}
                btn1Theme={dialog.btn1Theme}
                btn1Title={dialog.btn1Title || "btn1"}
                btn2Text={dialog.btn2Text}
                btn2Theme={dialog.btn2Theme}
                btn2Title={dialog.btn2Title || "btn2"}
                btn3Text={dialog.btn3Text}
                btn3Theme={dialog.btn3Theme}
                btn3Title={dialog.btn3Title || "btn3"}
                response={dialog.response}
            />}
            {loader !== null && <Loader
                title={loader.title}
                message={loader.message}
            />}
            {screenBlocker && <ScreenBlocker />}
        </div>
    );
}

export default OverlayHandler;
